<template>
  <span :class="classes">
    <span v-if="dot" :class="dotClass" />
    <slot name="icon" />
    <slot />
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  variant: { type: String, default: 'neutral' },
  size: { type: String, default: 'md' },
  dot: { type: Boolean, default: false },
  rounded: { type: String, default: 'full' } // 'full' | 'md'
})

const variantMap = {
  neutral: { bg: 'bg-ink-100 text-ink-700', dot: 'bg-ink-400', border: '' },
  brand: {
    bg: 'bg-brand-50 text-brand-700',
    dot: 'bg-brand-500',
    border: 'border border-brand-100'
  },
  accent: {
    bg: 'bg-accent-50 text-accent-600',
    dot: 'bg-accent-500',
    border: 'border border-accent-100'
  },
  success: {
    bg: 'bg-emerald-50 text-emerald-700',
    dot: 'bg-emerald-500',
    border: 'border border-emerald-100'
  },
  warning: {
    bg: 'bg-amber-50 text-amber-700',
    dot: 'bg-amber-500',
    border: 'border border-amber-100'
  },
  danger: { bg: 'bg-red-50 text-red-700', dot: 'bg-red-500', border: 'border border-red-100' },
  violet: {
    bg: 'bg-violet-50 text-violet-700',
    dot: 'bg-violet-500',
    border: 'border border-violet-100'
  },
  rose: { bg: 'bg-rose-50 text-rose-700', dot: 'bg-rose-500', border: 'border border-rose-100' },
  sky: { bg: 'bg-sky-50 text-sky-700', dot: 'bg-sky-500', border: 'border border-sky-100' }
}

const sizeMap = {
  sm: 'px-1.5 py-0.5 text-2xs gap-1',
  md: 'px-2.5 py-1 text-xs gap-1.5',
  lg: 'px-3 py-1.5 text-sm gap-2'
}

const classes = computed(() => {
  const v = variantMap[props.variant] || variantMap.neutral
  return [
    'inline-flex items-center font-semibold whitespace-nowrap',
    v.bg,
    v.border,
    sizeMap[props.size],
    props.rounded === 'full' ? 'rounded-full' : 'rounded-md'
  ]
})

const dotClass = computed(() => {
  const v = variantMap[props.variant] || variantMap.neutral
  return ['w-1.5 h-1.5 rounded-full flex-shrink-0', v.dot]
})
</script>
